import {useState, useCallback} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {connect} from 'react-redux'

import {get} from 'lodash'

import {useNavigate} from 'react-router-dom'

import {getErrorMessage} from '../../../utils'

import {useFetchLFFForTypeAndId} from '../../../hooks'

import {makeGetArtistById} from '../../../selectors'

import {destroy, deleteAccount, showAlert} from '../../../actions'

import ArtistForm from '../ArtistForm'


import Flier from '../../generics/flyers/Flier'


import {
  TipButton,
  // LikeIconButton,
  EditIconButton,
  ButtonGroupRound,
  DeleteIconButton,
  ShareIconButton,
  StatsIconButton,
  QRCodeIconButton,
  MessageIconButton,
  GradientPlayButton,
  FavoriteIconButton
} from '../../generics'




const styles = {
  buttonRow: css`
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    padding: 0px 0px 10px 0px;
    gap: 15px;

    @media (max-width: 550px) {
      flex-wrap: nowrap;
      overflow-x: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  `
}




const ArtistButtons = props => {

  const navigate = useNavigate()

  const [open, setOpen] = useState(false)


  const {
    artistId,
    name,
    claimed,
    isOwner,
    isEditor,
    isMerchant,
    imageURL,
    videoURL,
    destroy,
    showAlert,
    deleteAccount,
    originalImage
  } = props



  useFetchLFFForTypeAndId('artist', artistId)



  const deleteArtist = useCallback(() => {
    destroy('/artists/' + artistId, 'ARTIST').then(response => {
      showAlert('Artist deleted', 'info')
      deleteAccount()
      navigate(-1)
    })
    .catch(error => {
      const message = getErrorMessage(error)
      showAlert(message, 'error')
    })
  }, [artistId, destroy, deleteAccount, navigate, showAlert])



  function close() {
    setOpen(false)
  }



  const Buttons = useCallback(() => {
    if (isOwner || isEditor) {
      return ( 
        <>
          {videoURL &&
            <GradientPlayButton />
          }


          <EditIconButton open={open} setOpen={setOpen}>
            <ArtistForm artistId={artistId} close={close} />
          </EditIconButton>


          {(isOwner && !isMerchant) &&
            <TipButton id={artistId} type='artist' name={name} />
          }


          {/*<LikeIconButton id={artistId} type='artist' />*/}


          <ShareIconButton id={artistId} type='artist' />
          <StatsIconButton id={artistId} type='artist' />


          <QRCodeIconButton>
            <Flier 
              id={artistId} 
              type='artist' 
              name={name} 
              image={originalImage} 
            />
          </QRCodeIconButton>


          {isOwner &&
            <DeleteIconButton 
              imageURL={imageURL}
              title='Delete Artist'
              text='Are you sure you want to delete your artist account?'
              primaryAction={deleteArtist}
            />
          }
        </>
      )
    } else {
      return (
        <>
          {videoURL &&
            <GradientPlayButton />
          }

          <FavoriteIconButton id={artistId} type='artist' />

          {isMerchant && 
            <TipButton id={artistId} type='artist' name={name} />
          }

          {/*<LikeIconButton id={artistId} type='artist' />*/}
          {claimed &&
            <MessageIconButton 
              id={artistId} 
              type='artist' 
              name={name} 
              imageURL={imageURL}
            />
          }
          
          <ShareIconButton id={artistId} type='artist' />
        </>
      )
    }
  }, [
    name,
    open,
    claimed,
    isOwner,
    setOpen,
    artistId,
    imageURL,
    videoURL,
    isEditor,
    isMerchant,
    deleteArtist,
    originalImage
  ])

  




  return (
    <div css={styles.buttonRow}>
      <ButtonGroupRound>
        <Buttons />
      </ButtonGroupRound>
    </div>
  )
}



const makeMapStateToProps = () => {
  const getArtistById = makeGetArtistById()
  

  const mapStateToProps = (state, props) => {
    
    const id = props.artistId
    
    const artist = getArtistById(state, id).attributes

    const role = get(state, ['user', 'attributes', 'role'])

    const isOwner =  state.user.account.id === id

    const isEditor = ['admin', 'editor'].includes(role)



    return {
      name: artist.name,
      claimed: artist.claimed,
      isOwner: isOwner,
      isEditor: isEditor,
      isMerchant: artist?.isMerchant,
      imageURL: artist?.imageDerivatives?.small || '',
      videoURL: artist.video,
      originalImage: artist.image
    }
  }

  return mapStateToProps
}



const actions = {destroy, deleteAccount, showAlert}


export default connect(makeMapStateToProps, actions)(ArtistButtons)



